export const BUDGET_STORE = "budget_store";
export const DUE_DATES_STORE = "due_dates_store";
export const TEMPLATES_STORE = "templates_store";
export const ASSUMPTIONS_STORE = "assumptions_store";

export const BUDGET_IDX_KEYPATH = "budgetId";
export const BUDGET_IDX_NAME = "budget_idx";

export const CURRENT_BUDGET = "current_budget";
export const NEW_PREFIX = "new_";
export const IS_WORKFORCE_SCENARIO = "isWorkforceScenario";

export const START_KEY = 0;
export const ACCOUNTS_KEY = 1;
export const COMPANY_STRUCTURE_KEY = 2;
export const ASSUMPTION_KEY = 3;
export const SCHEDULES_KEY = 4;
export const TEMPLATES_KEY = 5;
export const WORKFORCE_KEY = 6;
export const OWNERS_KEY = 7;

export const UNDO = "UNDO";
export const CURRENT = "CURRENT";
export const REDO = "REDO";
export const UNDO_ALLOCATED = "UNDO_ALLOCATED";
export const REDO_ALLOCATED = "REDO_ALLOCATED";
export const UNDO_UNALLOCATED = "UNDO_UNALLOCATED";
export const REDO_UNALLOCATED = "REDO_UNALLOCATED";
